(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeDischargeTypeController', TypeDischargeTypeController);

    TypeDischargeTypeController.$inject = ['GenericEntityDatatableService', 'TypeDischargeType', 'CoreService',
        '$uibModal', 'ConfirmationService', '$q'];

    function TypeDischargeTypeController(GenericEntityDatatableService, TypeDischargeType, CoreService,
                                         $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Discharge Type',
            newButtonTitle: 'New Discharge Type',
            entityClassHumanized: 'Discharge Type',
            entityStateName: 'type-discharge-type',
            service: TypeDischargeType,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('acuity'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('acuity'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Discharge Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-discharge-type/update/type-discharge-type-dialog.html',
                controller: 'TypeDischargeTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            corporation: CoreService.getCorporation(),
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-discharge-type/update/type-discharge-type-dialog.html',
                controller: 'TypeDischargeTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeDischargeType', function (TypeDischargeType) {
                        return TypeDischargeType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Discharge Type').result.then(function () {
                    TypeDischargeType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
